<template>
  <div>
    <PageHeader>
      <button
        @click="handleBackButtonClick"
        class="btn btn-link text-uppercase"
        style="color: #484c54"
      >
        &#8592; Back to member profiles
      </button>
    </PageHeader>
    <PageContent>
      <template #filterBar>
        <form>
          <div class="row">
            <div class="col">
              <base-input label="Member ID">
                <a-input disabled v-model="memberData.membership_number" />
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-input label="First Name">
                <a-input disabled v-model="memberData.first_name" />
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-input label="Last Name">
                <a-input disabled v-model="memberData.last_name" />
              </base-input>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col">
              <base-input label="Total Points">
                <a-input disabled v-model="availablePoints" />
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-input label="Total Active Points">
                <a-input disabled v-model="current_points_balance_active" />
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <base-input label="Total Expiring Points">
                <a-input disabled v-model="current_points_balance_expiring" />
              </base-input>
            </div>
          </div>
        </form>
      </template>
      <template #pageTable>
        <h6 class="heading-small text-muted mb-4">Redeem Item</h6>
        <div class="row">
          <div class="col-sm-3">
            <base-input label="Item Barcode">
              <a-input
                @keyup="handleKeyUp"
                @keyup.enter="fetchItemData"
                v-model="formdata.barcode"
              />
            </base-input>
          </div>
          <div class="col-sm-4">
            <base-input label="Item Description">
              <a-input v-model="formdata.description" :disabled="true" />
            </base-input>
          </div>
        </div>
        <div class="row mb-4" v-if="validPoints">
          <div class="col-sm-3">
            <a-spin :spinning="isRedeeming">
              <a-popconfirm
                title="Are you sure you want to redeem this item?"
                @confirm="redeemItem"
                okText="Yes"
                cancelText="Cancel"
              >
                <a
                  class="btn btn-outline-primary btn-sm"
                  :disabled="isRedeeming"
                  >Redeem</a
                >
              </a-popconfirm>
            </a-spin>
          </div>
          <div class="col-sm-6">
            <small v-if="insufficient_points" class="text-danger">
              <i> Member does not have sufficient points to redeem item.</i>
            </small>
          </div>
        </div>
        <PageTable
          v-if="isLoaded"
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <template #tableButtons="{ tableProps }">
            <div v-if="tableProps.rowData.points_to_redeem < availablePoints">
              <a-spin :spinning="isRedeeming">
                <a-popconfirm
                  v-if="!smsOtpItemRedemptionSetting"
                  title="Are you sure you want to redeem this item?"
                  @confirm="redeemFromTable(tableProps.rowData)"
                  okText="Yes"
                  cancelText="Cancel"
                >
                  <a
                    class="btn btn-warning btn-sm text-white"
                    :disabled="isRedeeming"
                    >Redeem</a
                  >
                </a-popconfirm>

                <a-popconfirm
                  v-else
                  title="Are you sure you want to redeem this item?"
                  @confirm="requestSmsOtp(tableProps.rowData)"
                  okText="Yes"
                  cancelText="Cancel"
                >
                  <a
                    class="btn btn-warning btn-sm text-white"
                    :disabled="isRedeeming"
                    >Redeem</a
                  >
                </a-popconfirm>
              </a-spin>
            </div>
            <div v-else>
              <span class="text-danger">Insufficient Points</span>
            </div>
          </template>
        </PageTable>
        <PageTable
          v-if="isLoaded"
          :tableTitle="tableHistory.title"
          :apiUrl="tableHistory.apiUrl"
          :tableFields="tableHistory.fields"
          :appendedParams="tableHistory.filters"
        >
          <template #tableButtons="{ tableProps }">
            <div>
              <a-button type="link" @click="openItemDetails(tableProps)">
                {{ tableProps.rowData.reference_id }}
              </a-button>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>

    <a-modal
      v-model="smsOtpModal"
      title="OTP Verification Form"
      @ok="
        () => {
          redeem();
          this.smsOtpModal = false;
        }
      "
      @cancel="
        () => {
          this.otp = {
            source: null,
            code: null
          };
        }
      "
    >
      <p>Please enter the OTP sent to your <b>Mobile Number</b></p>
      <small
        >This authentication is to verify that you redeeming an item.</small
      >
      <a-input
        v-model="otp.code"
        placeholder="Enter received OTP from mobile number"
      />
    </a-modal>
    <a-drawer
      :width="itemTransactionDetailDrawer.width"
      :placement="itemTransactionDetailDrawer.placement"
      :visible="itemTransactionDetailDrawer.visible"
      @close="closeItemTransactionDetailDrawer"
    >
      <TransactionDetailForm
        :itemTransactionData="itemTransactionData"
        @closeDrawer="closeItemTransactionDetailDrawer"
        :viewMode="itemTransactionDetailViewMode"
      />
    </a-drawer>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import HTTPRequest from '../../controllers/httpRequest';
import TransactionDetailForm from './TransactionDetailForm.vue';
import secureStorage from '@/controllers/secureStorage';
import moment from 'moment-timezone';
const ENV = process.env.VUE_APP_ENV;
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  name: 'ItemRedemptionForm',
  components: {
    PageHeader,
    PageContent,
    PageTable,
    TransactionDetailForm
  },
  data() {
    return {
      member: null,
      isLoaded: false,
      isRedeeming: false,
      validPoints: false,
      itemTransactionData: {},
      insufficient_points: false,
      smsOtpItemRedemptionSetting: false,
      smsOtpModal: false,
      rowData: null,
      itemTransactionDetailViewMode: false,
      itemTransactionDetailDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      memberData: {
        id: null,
        first_name: null,
        last_name: null
      },
      otp: {
        code: null,
        source: null
      },
      dateFormat: 'YYYY-MM-DD',
      formdata: {
        id: null,
        barcode: '',
        description: ''
      },
      table: {
        title: 'Item List',
        apiUrl:
          '/api/v1/clp_items/redemption_list?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [
          { name: 'description', title: 'Item Description' },
          { name: 'code', title: 'Item Code' },
          { name: 'barcode', title: 'Item Barcode' },
          { name: 'points_to_redeem', title: 'Points Required' },
          'actions'
        ],
        filters: {
          membership_program_id: null,
          membership_level_id: null
        }
      },
      tableHistory: {
        title: 'Item Redemption History',
        apiUrl: '/api/v1/clp_items/redemption_history',
        fields: [
          {
            name: 'created_at',
            title: 'Transaction Date',
            formatter(date) {
              if (moment(date).isValid()) {
                if (ENV === 'development') {
                  return moment(date).format('MM/DD/YYYY');
                } else {
                  return moment.tz(date, TIMEZONE).utc().format('MM/DD/YYYY');
                }
              }
              return null;
            }
          },
          { name: 'actions', title: 'Transaction ID' },
          { name: 'item.description', title: 'Item Description' },
          { name: 'item.code', title: 'Item Code' },
          { name: 'points', title: 'Points Used' }
        ],
        filters: {
          member_id: null
        }
      }
    };
  },
  methods: {
    handleBackButtonClick() {
      let filter = this.$store.getters.getMemberProfileFilter;
      filter.fromBackButton = true;
      this.$store.dispatch('setMemberProfileFilter', filter);
      this.$router.go(-1);
    },
    moment,
    applyFilter() {
      this.$root.$emit('refreshTable');
    },
    closeItemTransactionDetailDrawer() {
      this.$emit('closeDrawer', null);
      this.itemTransactionData = {};
      this.itemTransactionDetailDrawer.visible = false;
      this.itemTransactionDetailViewMode = false;
      this.closeDrawer();
    },
    openItemDetails(row) {
      let user = row.rowData?.createdByUser?.user_name;
      this.itemTransactionData = {
        transaction_date: row.rowData.created_at,
        transaction_number: row.rowData.reference_id,
        branch: row.rowData.branch,
        member_id: row.rowData?.member?.membership_number,
        card_number: row.rowData.card_number,
        item_code: row.rowData.item_code,
        points_used: row.rowData.points,
        createdByUser: {
          user_name: user ? user : secureStorage.getItem('username')
        }
      };
      this.itemTransactionDetailDrawer.visible = true;
      this.itemTransactionDetailViewMode = true;
    },
    closeDrawer() {
      this.itemTransactionData = {};
      this.$emit('closeDrawer', null);
    },
    async redeemItem() {
      const { membership_level_id, membership_program_id } = this.member;
      const member_id = this.member.id;
      let params = {
        item_redemption: {
          membership_program_id,
          membership_level_id,
          member_id,
          item_id: this.formdata.id,
          reference_transaction_date: moment
            .tz(TIMEZONE)
            .format('YYYY-MM-DD h:mm A')
        }
      };
      if (this.smsOtpItemRedemptionSetting) {
        params.otp = this.otp;
      }
      this.isRedeeming = true;
      const response = await HTTPRequest.postRequest(
        `/api/v1/clp_item_redemptions/redeem/?origin_site_id=` +
          secureStorage.getItem('currentSiteId'),
        params
      );
      if (response.message == 'Success') {
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Item has been successfully redeemed.'
        });
        this.getMemberData(this.member.id);
        this.itemTransactionData = {
          transaction_date: response.data.created_at,
          transaction_number: response.data.reference_id,
          branch: response.data.branch,
          member_id: this.memberData.membership_number,
          card_number: response.data.card_number,
          item_code: response.data.item_code,
          points_used: response.data.points,
          createdByUser: {
            user_name: secureStorage.getItem('username')
          }
        };
        this.itemTransactionDetailDrawer.visible = true;
        this.itemTransactionDetailViewMode = true;
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
      this.rowData = null;
      this.otp = {
        source: null,
        code: null
      };
      this.isRedeeming = false;
    },
    handleKeyUp() {
      this.validPoints = false;
    },
    async fetchItemData() {
      const { membership_program_id, membership_level_id } = this.member;
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_items/fetch_by/${this.formdata.barcode}/barcode?origin_site_id=` +
          secureStorage.getItem('currentSiteId'),
        { membership_program_id, membership_level_id }
      );
      if (data.id != undefined) {
        this.formdata.description = data.description;
        this.formdata.id = data.id;
        if (this.availablePoints < data.points_to_redeem) {
          this.validPoints = false;
          this.insufficient_points = true;
        } else {
          this.validPoints = true;
        }
      } else {
        this.formdata.id = null;
        this.formdata.description = '';
        if (data.error != undefined) {
          this.$notification.error({
            message: data.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },
    async getMemberData(memberId) {
      const data = await HTTPRequest.getRequest(
        '/api/v1/clp_members/' +
          memberId +
          '?withSmsOtpItemRedemptionSettings=true'
      );
      this.memberData = data;
      this.table.filters.membership_program_id =
        this.memberData.membership_program_id;
      this.table.filters.membership_level_id =
        this.memberData.membership_level_id;

      this.tableHistory.filters.member_id = this.memberData.id;
      this.smsOtpItemRedemptionSetting = Boolean(
        parseInt(this.memberData.smsOtpItemRedemptionSetting.value)
      );
      this.isLoaded = true;
    },

    async requestSmsOtp(rowData) {
      this.isRedeeming = true;
      this.rowData = rowData;
      const response = await HTTPRequest.postRequest(
        '/api/v1/clp_otp_verifications/item_redemption_request/',
        {
          otp_verification: {
            member_id: this.memberData.id,
            mobile_number: this.memberData.mobile_no
          }
        }
      );

      if (response) {
        this.smsOtpModal = true;
        this.otp.source = response.source;
      } else {
        this.smsOtpModal = false;
        this.otp.source = null;
      }
      this.isRedeeming = false;
    },

    async redeemFromTable(rowData) {
      const { id } = rowData || this.rowData;

      const { membership_level_id, membership_program_id } = this.member;

      const member_id = this.member.id;

      let params = {
        item_redemption: {
          membership_program_id,
          membership_level_id,
          member_id,
          item_id: id,
          reference_transaction_date: moment
            .tz(TIMEZONE)
            .format('YYYY-MM-DD HH:mm:ss')
        }
      };

      if (this.smsOtpItemRedemptionSetting) {
        params.otp = this.otp;
      }

      this.isRedeeming = true;
      const response = await HTTPRequest.postRequest(
        `/api/v1/clp_item_redemptions/redeem/?origin_site_id=` +
          secureStorage.getItem('currentSiteId'),
        params
      );

      if (response.message == 'Success') {
        // Success message
        this.$notification.success({
          message: 'Item has been successfully redeemed.'
        });
        // refresh page/table
        this.getMemberData(this.member.id);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
      this.rowData = null;
      this.otp = {
        source: null,
        code: null
      };
      this.isRedeeming = false;
    }
  },

  computed: {
    current_points_balance_active() {
      return this.memberData?.current_points_balance_active;
    },
    current_points_balance_expiring() {
      return this.memberData?.current_points_balance_expiring;
    },
    availablePoints: function () {
      return (
        parseFloat(this.memberData?.current_points_balance_active) +
        parseFloat(this.memberData?.current_points_balance_expiring)
      );
    }
  },

  created() {
    this.member = this.$store.getters.getCurrentMember;
    if (this.member == null) {
      this.$router.go(-1);
    } else {
      console.log('memberData: ', this.memberData);
      this.getMemberData(this.member.id);
    }
  }
};
</script>

<style scoped></style>
